<template>
  <el-drawer
    :visible.sync="isVisibleDrawerOrder"
    @closed="onClickCloseForm"
    size="94%"
    :append-to-body="false"
    :modal-append-to-body="false"
    :show-close="false"
    :modal="false"
    v-loading.lock="isLoadingForms"
    element-loading-text="載入中..."
  >
    <template #title>
      <div style="display: flex; align-items: center;">
        <el-button type="text" icon="el-icon-close" @click="isVisibleDrawerOrder = false" style="font-size: 32px; font-weight:500" />
      </div>
    </template>
    <template>
      <section id="print-able" class="drawer-layout Jost">
        <div class="drawer-layout__scroll">
          <div class="drawer-layout__header">
            <div style="display: flex; justify-content: space-between; align-items: center;">
              <div style="color:#000000">住宿單</div>
              <div style="color:#000000;font-size:16px">訂單編號：{{ stay.orderId }}</div>
            </div>
          </div>

          <div class="drawer-layout__content" style="background-color: #ffffff;border-radius: 8px;padding:30px 24px">
            <!-- 訂單資訊 -->
            <section>
              <div>
                <el-row>
                  <el-col :span="7">
                    飼主名字：<span style="color:#000000">{{ stay.ownerName }}</span>
                  </el-col>
                  <el-col :span="7">
                    入住日期：<span style="color:#000000">{{ stay.checkInDate }}</span>
                  </el-col>
                  <el-col :span="10">
                    消費金額：<span style="color:#000000">{{ stay.amount }}</span>
                  </el-col>
                </el-row>
                <el-row style="margin-top:12px;">
                  <el-col :span="7">
                    飼主電話：<span style="color:#000000">{{ stay.ownerPhone }}</span>
                  </el-col>
                  <el-col :span="7">
                    退房日期：<span style="color:#000000">{{ stay.checkOutDate }}</span>
                  </el-col>
                  <el-col :span="10">
                    住宿房型：<span style="color:#000000">{{ stay.roomTypes }}</span>
                  </el-col>
                </el-row>
              </div>
            </section>
            <!-- 入住寵物資訊-->
            <section>
              <div v-for="pet in pets" style="border: solid 1px #E6E7EB; border-radius: 8px;padding:20px;margin-top:18px;">
                <el-row>
                  <el-col :span="12">
                    <el-row :gutter="10">
                      <el-col :span="8" style="font-size:16px;color:#000000;font-weight: 600;">{{ pet.name }}</el-col>
                      <el-col :span="8" style="">{{ pet.species }}/{{ pet.weight }}含以下</el-col>
                      <el-col :span="8" style="">{{ pet.gender }}/{{ pet.age }}</el-col>
                    </el-row>
                  </el-col>
                  <el-col :span="12">
                    <el-row :gutter="10">
                      <el-col :span="10">
                        緊急聯絡人：<span style="color:#000000">{{ pet.emergencyContact }}</span>
                      </el-col>
                      <el-col :span="14">
                        聯絡電話：<span style="color:#000000">{{ pet.phone }}</span>
                      </el-col>
                    </el-row>
                  </el-col>
                </el-row>
                <el-row style="margin-top:8px;">
                  <el-col :span="12">
                    <el-row :gutter="10">
                      <el-col :span="8">
                        寵登：<span style="color:#000000">{{ pet.petRegistration }}</span>
                      </el-col>
                      <el-col :span="16">
                        晶片：<span style="color:#000000">{{ pet.chip }}</span>
                      </el-col>
                    </el-row>
                  </el-col>
                  <el-col :span="12">
                    獸醫院名稱：<span style="color:#000000">{{ pet.vetAddress }}</span>
                  </el-col>
                </el-row>
                <el-row style="margin-top:8px;">
                  <el-col :span="12">
                    <el-row :gutter="10">
                      <el-col :span="8">
                        結紮：<span style="color:#000000">{{ pet.neutered }}</span>
                      </el-col>
                      <el-col :span="16" style="">
                        點除蚤藥日期：<span style="color:#000000">{{ pet.fleaDate }}</span>
                      </el-col>
                    </el-row>
                  </el-col>
                  <el-col :span="12">
                    獸醫院電話：<span style="color:#000000">{{ pet.vetPhone }}</span>
                  </el-col>
                </el-row>
                <el-row style="margin-top:8px;">
                  <el-col :span="12">
                    <div style="opacity:0">-</div>
                  </el-col>
                  <el-col :span="12">
                    獸醫院地址：<span style="color:#000000">{{ pet.vetAddress }}</span>
                  </el-col>
                </el-row>
              </div>
            </section>
            <!-- 問答題專區 -->
            <el-form ref="ruleForm" :model="{ formItems, orderFormMeta }" label-width="0px">
              <section v-if="mode === 'edit'" class="print-notShow">
                <div v-for="(item, index) in formItems" :key="item.id" style="margin-top: 18px;">
                  <el-form-item :prop="'formItems.' + index + '.value'" :rules="[{ required: item.isRequired, message: '此欄位必填', trigger: item.type === 'text' ? 'blur' : 'change' }]">
                    <div style="font-size: 16px; font-weight:500;color:#000000; margin-bottom: 8px;">
                      {{ item.title }}
                      <span v-if="item.isRequired" style="color: #F56C6C;">*</span>
                    </div>

                    <el-input v-if="item.type === 'text'" v-model="item.value" type="textarea" :rows="4" placeholder="請詳細說明" />

                    <el-radio-group v-else-if="item.type === 'single'" v-model="item.value" class="grid-group">
                      <el-radio v-for="option in item.options" :key="option" :label="option" border class="grid-item single">
                        {{ option }}
                      </el-radio>
                    </el-radio-group>

                    <el-checkbox-group v-else-if="item.type === 'multiple'" v-model="item.value" class="grid-group">
                      <el-checkbox v-for="option in item.options" :key="option" :label="option" border class="grid-item">
                        {{ option }}
                      </el-checkbox>
                    </el-checkbox-group>
                  </el-form-item>
                </div>

                <div style="margin-top: 18px;">
                  <div style="font-size: 16px; font-weight:500;color:#000000">其他備註</div>
                  <el-input v-model="orderFormMeta.otherNote" type="textarea" :rows="4" placeholder="請輸入其他備註" />
                </div>

                <div style="margin-top: 18px;">
                  <div style="font-size: 16px; font-weight:500;color:#000000">需要特別注意的醫療資訊</div>
                  <el-input v-model="orderFormMeta.medicalNote" type="textarea" :rows="4" placeholder="請輸入醫療資訊" />
                </div>

                <div style="margin-top: 18px;">
                  <div style="font-size: 16px; font-weight:500;color:#000000; margin-bottom: 8px;">住宿契約</div>

                  <div class="terms-container" ref="termsBox" @scroll="handleTermsScroll">{{ orderFormMeta.terms }}</div>

                  <div class="terms-checkbox-wrapper">
                    <el-checkbox v-model="isTermsAgreed" :disabled="hasAgreedTermsOnce || !isTermsScrollEnd">
                      <span :style="{ color: isTermsAgreed ? '#ea6a2a' : '#999', fontWeight: 'bold' }">
                        我已閱讀並同意
                      </span>
                    </el-checkbox>
                  </div>
                </div>
              </section>
            </el-form>
            <!-- 保留 mode === edit時 不掛載這裡的DOM -->
            <section v-if="mode === 'view'">
              <!-- 因為列印掛載的問題 所以裡面再寫一層 -->
              <section v-show="mode === 'view'">
                <el-row :gutter="20">
                  <el-col v-for="item in formItems" :key="item.id" :span="12" style="margin-top: 18px;">
                    <!-- 問題抬頭 -->
                    <div style="font-size: 16px; color:#6C6B6B">
                      {{ item.title }}
                    </div>

                    <!-- 顯示回答 -->
                    <div style="margin-top: 6px; font-size: 16px;font-weight:500; color:#000000;">
                      <!-- 單選題 -->
                      <div v-if="item.type === 'single'">
                        {{ item.value ? item.value : '尚未回答' }}
                      </div>

                      <!-- 多選題 -->
                      <div v-else-if="item.type === 'multiple'">
                        <span v-if="item.value && item.value.length > 0">
                          {{ item.value.join('、') }}
                        </span>
                        <span v-else>尚未回答</span>
                      </div>

                      <!-- 文字題 -->
                      <div v-else-if="item.type === 'text'">
                        {{ item.value && item.value.trim() !== '' ? item.value : '尚未回答' }}
                      </div>
                    </div>
                  </el-col>
                </el-row>
                <el-row :gutter="20" style="margin-top: 18px;">
                  <el-col :span="12">
                    <div style="font-size: 16px; color:#6C6B6B">其他備註</div>
                    <div style="margin-top: 6px; font-size: 16px;font-weight:500; color:#000000;">
                      {{ orderFormMeta.otherNote && orderFormMeta.otherNote.trim() !== '' ? orderFormMeta.otherNote : '尚未回答' }}
                    </div>
                  </el-col>
                  <el-col :span="12">
                    <div style="font-size: 16px; color:#6C6B6B">需要特別注意的醫療資訊</div>
                    <div style="margin-top: 6px; font-size: 16px;font-weight:500; color:#000000;">
                      {{ orderFormMeta.medicalNote && orderFormMeta.medicalNote.trim() !== '' ? orderFormMeta.medicalNote : '尚未回答' }}
                    </div>
                  </el-col>
                </el-row>
                <el-row class="print-section-terms">
                  <el-col>
                    <div style="font-size: 16px; color:#6C6B6B;margin-top:18px">住宿契約</div>
                    <div style="margin-top: 6px; font-size: 16px;color:#000000;white-space: pre-wrap;border: solid 1px #E6E7EB; border-radius: 8px;padding:20px;">{{
                      orderFormMeta.terms && orderFormMeta.terms.trim() !== '' ? orderFormMeta.terms : '尚未回答'
                    }}</div>
                  </el-col>
                </el-row>
              </section>
            </section>

            <!-- 簽名確認 -->
            <div class="print-section-signature">
              <SignaturePad :key="signaturePadKey" style="margin-top:18px" :mode="mode" :signature-path="orderFormMeta.signaturePath" @signatureSaved="handleSignatureSaved" />
            </div>
          </div>
        </div>
      </section>
    </template>
    <!-- 底部固定按鈕區 -->
    <div
      style="z-index:5; position: fixed; bottom: 0px; right: 0px;
		background-color: white; width: 95%;
		border-top: 1px solid #E6E6E6; height:70px;
		text-align: center;display: flex; align-items: center; justify-content: center;"
      class="Jost print-notShow"
    >
      <div style="display: flex; align-items: center; justify-content: center; gap: 12px; width: 90%; padding: 0 10px;">
        <template v-if="mode === 'edit'">
          <el-button round style="flex: 1; margin: 0;" @click="onClickCloseForm">取消</el-button>
          <el-button type="primary" round style="flex: 1; margin: 0;" :loading="isLoading" :disabled="!canConfirmCheckIn" @click="onClickConfirm">確認報到</el-button>
        </template>

        <template v-else>
          <el-button round style="flex: 1; margin: 0;" @click="onClickCloseForm">取消</el-button>
          <el-button round style="flex: 1; margin: 0;" @click="onClickPrint">列印</el-button>
          <!-- <el-button type="primary" round style="flex: 1; margin: 0;" :disabled="true" @click="onClickExport">匯出</el-button> -->
        </template>
      </div>
    </div>
  </el-drawer>
</template>

<script>
import SignaturePad from './partials/checkInForm/SignaturePad.vue'
import { getOrderForm } from '@/src/router/views/schedule/hotel/api/order'
import API from '../../api'

export default {
  name: 'hotelCheckInForm',
  components: {
    SignaturePad,
  },
  props: {
    // 控制建立訂單流程抽屜顯示與否
    value: {
      type: Boolean,
      default: true,
    },
    mode: {
      type: String,
      default: 'edit', // 'edit' 編輯模式 , 'view' 檢視模式
    },
    productId: {
      type: [String, Number],
      default: null,
    },
    containerId: {
      type: [String, Number],
      default: null,
    },
    orderId: {
      type: [String, Number],
      default: null,
    },
    stayInfo: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      formItems: [],
      isLoading: false,
      isLoadingForms: false,
      orderFormMeta: {},
      pets: [],
      stay: {
        orderId: '-',
        ownerName: '-',
        checkInDate: '-',
        amount: '-',
        ownerPhone: '-',
        checkOutDate: '-',
        roomTypes: '-',
      },
      isTermsAgreed: false,
      isTermsScrollEnd: false,
      hasAgreedTermsOnce: false,
      agreedOrderId: null,
      signaturePadKey: 0,
    }
  },
  updated() {
    // 移除 aria-hidden 屬性，避免瀏覽器報「焦點元素被隱藏」
    this.$nextTick(() => {
      document.querySelectorAll('.el-radio__original, .el-checkbox__original').forEach((el) => el.removeAttribute('aria-hidden'))
    })
  },
  computed: {
    isVisibleDrawerOrder: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      },
    },
    canConfirmCheckIn() {
      return this.isTermsAgreed && !this.isLoading
    },
  },
  watch: {
    value: {
      immediate: true,
      handler(isOpen) {
        if (isOpen) {
          this.fetchOrderForm()
        } else if (!this.hasAgreedTermsOnce) {
          this.clearTermsAgreementDraft()
        }
      },
    },
    orderId(newVal, oldVal) {
      if (oldVal != null && newVal !== oldVal) {
        this.resetTermsAgreement()
      }
      if (this.value) this.fetchOrderForm()
    },
    productId() {
      if (this.value) this.fetchOrderForm()
    },
    containerId() {
      if (this.value) this.fetchOrderForm()
    },
    stayInfo: {
      immediate: true,
      handler(info) {
        if (!info) return
        this.stay = {
          ...this.stay,
          ...info,
        }
      },
    },
  },
  methods: {
    async fetchOrderForm() {
      if (this.isLoadingForms) return
      if (!this.productId || !this.containerId || !this.orderId) return
      this.isLoadingForms = true
      try {
        const orderForm = await getOrderForm(this.productId, this.containerId, this.orderId)
        console.log(orderForm)
        this.applyOrderFormData(orderForm)
      } catch (error) {
        this.formItems = []
        this.pets = []
        this.$message({
          type: 'error',
          message: '取得住宿單內容失敗，請稍後再試。',
        })
      } finally {
        this.isLoadingForms = false
      }
    },
    applyOrderFormData(orderForm) {
      if (!orderForm || typeof orderForm !== 'object') {
        this.formItems = []
        this.pets = []
        return
      }
      const forms = orderForm.forms && orderForm.forms.CHECK_IN ? orderForm.forms.CHECK_IN : []
      this.formItems = Array.isArray(forms) ? forms.map(this.normalizeFormItem).filter(Boolean) : []

      const normalizedItems = Array.isArray(forms) ? forms.map(this.normalizeFormItem).filter(Boolean) : []
      //定義排序權重 (越小越靠前)
      const typeOrder = {
        single: 1,
        multiple: 2,
        text: 3,
      }
      this.formItems = normalizedItems.sort((a, b) => {
        const scoreA = typeOrder[a.type] || 99 // 若不在定義內則排最後
        const scoreB = typeOrder[b.type] || 99
        return scoreA - scoreB
      })

      const guests = Array.isArray(orderForm.guests) ? orderForm.guests : []
      this.pets = guests.map(this.mapGuestToPet)
      this.orderFormMeta = {
        otherNote: orderForm.otherNote || null,
        medicalNote: orderForm.medicalNote || null,
        signaturePath: orderForm.signaturePath || null,
        terms: orderForm.terms || null,
      }
      if (orderForm.orderId) {
        this.stay = {
          ...this.stay,
          orderId: orderForm.orderId,
        }
      }
      this.restoreTermsAgreement()
      this.checkTermsScrollable()
    },
    normalizeFormItem(item) {
      if (!item || typeof item !== 'object') return null
      const type = item.type || item.form_type || 'text'
      let value = ''
      if (type === 'single') value = null
      else if (type === 'multiple') value = []
      if (item.answer != null) {
        if (type === 'multiple') value = Array.isArray(item.answer) ? item.answer : [item.answer]
        else value = item.answer
      }
      return {
        id: item.id,
        title: item.title || '',
        type,
        options: Array.isArray(item.options) ? item.options : [],
        value,
        isRequired: item.isRequired || false,
      }
    },
    mapGuestToPet(guest) {
      const questions = guest.petQuestions || {}
      const genderMap = {
        male: '公',
        female: '母',
      }
      const genderRaw = (guest.gender || '').toString().toLowerCase()
      const category = guest.category || {}
      const categoryTags = Array.isArray(category.tags) ? category.tags : []
      const categoryTagText = categoryTags.length ? categoryTags.join(' / ') : '-'
      return {
        name: guest.name || '-',
        species: guest.breed || '-',
        weight: category.title || '-',
        gender: genderMap[genderRaw] || guest.gender || '-',
        age: categoryTagText,
        emergencyContact: '-',
        phone: guest.phone || '-',
        petRegistration: questions.register != null ? (questions.register ? '有' : '無') : '-',
        chip: questions.chipNumber || '-',
        vetName: questions.vetName || '-',
        neutered: questions.ligation != null ? (questions.ligation ? '是' : '否') : '-',
        fleaDate: questions.fleaMedicineDate || '-',
        vetPhone: questions.vetPhone || '-',
        vetAddress: questions.vetAddress || '-',
      }
    },
    onClickCloseForm() {
      if (!this.hasAgreedTermsOnce) {
        this.clearTermsAgreementDraft()
      }
      this.isVisibleDrawerOrder = false
      this.$emit('close')
    },
    onClickPrint() {
      const drawer = document.querySelector('.el-drawer__wrapper')
      if (drawer) drawer.style.visibility = 'hidden'

      const printContent = document.getElementById('print-able').innerHTML
      const printArea = document.createElement('div')
      printArea.id = 'print-area'
      printArea.innerHTML = printContent
      document.body.appendChild(printArea)

      setTimeout(() => {
        window.print()
        document.body.removeChild(printArea)

        // 列印完再顯示 Drawer
        if (drawer) drawer.style.visibility = ''
      }, 100)
    },
    async onClickConfirm() {
      this.isLoading = true
      this.removeButtonFocus()

      if (!this.isTermsAgreed) {
        this.$message.error('請先閱讀並同意住宿契約')
        this.isLoading = false
        return
      }

      try {
        await this.$confirm('確定將此修改為「已報到」狀態？', '報到', {
          confirmButtonText: '確定',
          cancelButtonText: '否',
          modalAppendToBody: false,
          showClose: false,
          center: true,
        })

        try {
          await this.$refs.ruleForm.validate()
        } catch (validationError) {
          this.$message.error('請填寫所有必填欄位')

          // 優化體驗：自動捲動到第一個錯誤的位置
          this.$nextTick(() => {
            const errorElement = document.getElementsByClassName('is-error')[0]
            if (errorElement) {
              errorElement.scrollIntoView({ behavior: 'smooth', block: 'center' })
            }
          })

          throw 'cancel' // 終止流程，進入最外層 catch
        }

        await API.order.postHotelOrderForm(this.productId, this.containerId, this.orderId, this.buildCheckInFormPayload())
        await API.order.postHotelOrderAction(this.productId, this.containerId, this.orderId, { action: 'CHECK_IN' })

        this.hasAgreedTermsOnce = true
        this.agreedOrderId = this.orderId
        this.$emit('submit-check-in')
        this.isVisibleDrawerOrder = false
        this.$message.success('已成功修改為已報到狀態')
      } catch (err) {
        // 統一錯誤處理
        if (err === 'cancel' || err === 'close') {
          // 使用者取消確認，或表單驗證失敗拋出的 'cancel'
          console.log('操作已取消或驗證未通過')
        } else {
          console.error('修改狀態失敗:', err)
          this.$message.error('操作失敗，請稍後再試')
        }
      } finally {
        this.isLoading = false
      }
    },
    buildCheckInFormPayload() {
      return {
        data: {
          type: 'CHECK_IN',
          forms: this.formItems.map((item) => ({
            id: item.id,
            title: item.title,
            type: item.type,
            options: item.options,
            answer: item.value,
          })),
          otherNote: this.orderFormMeta.otherNote,
          medicalNote: this.orderFormMeta.medicalNote,
          signaturePath: this.orderFormMeta.signaturePath,
        },
      }
    },
    async handleSignatureSaved(signatureData) {
      if (this.mode !== 'view') {
        this.orderFormMeta.signaturePath = signatureData
        return
      }

      const previousPath = this.orderFormMeta.signaturePath
      this.orderFormMeta.signaturePath = signatureData
      this.isLoading = true
      try {
        await API.order.postHotelOrderForm(this.productId, this.containerId, this.orderId, this.buildCheckInFormPayload())
        this.$message.success('簽名已儲存')
        this.$emit('submit-check-in')
      } catch (err) {
        console.error('儲存簽名失敗:', err)
        this.$message.error('儲存簽名失敗，請稍後再試')
        this.orderFormMeta.signaturePath = previousPath
        this.signaturePadKey += 1
      } finally {
        this.isLoading = false
      }
    },
    handleTermsScroll() {
      const el = this.$refs.termsBox
      if (!el) return

      // 判斷是否滾動到底部 (容許 10px 的誤差)
      const isAtBottom = el.scrollTop + el.clientHeight >= el.scrollHeight - 10

      if (isAtBottom && !this.isTermsScrollEnd) {
        this.isTermsScrollEnd = true
        this.isTermsAgreed = true // 滾到底自動勾選
      }
    },

    resetTermsAgreement() {
      this.hasAgreedTermsOnce = false
      this.agreedOrderId = null
      this.clearTermsAgreementDraft()
    },
    clearTermsAgreementDraft() {
      this.isTermsAgreed = false
      this.isTermsScrollEnd = false
    },
    restoreTermsAgreement() {
      if (this.hasAgreedTermsOnce && this.agreedOrderId === this.orderId) {
        this.isTermsAgreed = true
        this.isTermsScrollEnd = true
      }
    },
    checkTermsScrollable() {
      if (this.hasAgreedTermsOnce) return
      this.$nextTick(() => {
        const el = this.$refs.termsBox
        if (el && el.scrollHeight <= el.clientHeight) {
          // 如果內容太少不需要捲動，直接視為已捲動到底
          this.isTermsScrollEnd = true
        }
      })
    },
    removeButtonFocus() {
      this.$nextTick(() => {
        setTimeout(() => {
          if (document.activeElement) document.activeElement.blur()
        }, 50)
      })
    },
  },
}
</script>

<style lang="scss" scoped>
::v-deep .el-drawer__header {
  position: fixed;
  top: 0px;
  left: 75px;
  padding: 0px;
}

::v-deep .el-drawer__close-btn {
  font-size: 2.5rem;
}

::v-deep .el-drawer__body {
  padding: 0px;
  padding-bottom: 50px;
}

::v-deep .el-textarea__inner {
  border: solid 1px #e5e7eb;
  border-radius: 8px;
  font-size: 18px;
  background-color: #ffffff;

  &:focus {
    border: solid 1px #ea6a29;
  }
}

::v-deep .el-checkbox.is-bordered + .el-checkbox.is-bordered {
  margin-left: 0px;
}

::v-deep .el-radio.is-bordered + .el-radio.is-bordered {
  margin-left: 0px;
}

.grid-group {
  display: grid;
  grid-template-columns: repeat(2, 1fr); /* 一列兩欄 */
  gap: 18px;
}

.grid-item {
  width: 100%;
  border-radius: 8px;
  padding: 12px 20px;
  height: 46px;
  &.single {
    padding: 16px 20px;
  }
}

.drawer-layout {
  display: flex;
  flex-direction: column; // 改成上下排列
  height: calc(100vh - 60px);
  width: 100%;
  position: relative;
  padding: 0px 12px;

  &__scroll {
    flex: 1;
    overflow-y: auto;
    display: flex;
    flex-direction: column;
    padding: 0px 18px;
    font-size: 16px;
    line-height: 1.8;

    /* scrollbar 樣式 */
    &::-webkit-scrollbar {
      width: 8px;
    }
    &::-webkit-scrollbar-track {
      background: #f0f0f0;
      border-radius: 4px;
    }
    &::-webkit-scrollbar-thumb {
      background-color: #999;
      border-radius: 4px;
      border: 2px solid #f0f0f0;
    }
    &::-webkit-scrollbar-thumb:hover {
      background-color: #666;
    }
  }

  &__header {
    position: sticky;
    top: 0;
    padding: 8px 0;
    z-index: 10;
    background-color: #f9f9fb;
    border-bottom: 1px solid #e6e6e6;
    font-size: 20px;
    font-weight: 700;
    line-height: 2.2;
  }

  &__content {
    margin: 20px 0 50px;
    font-size: 14px;
  }
}

.terms-container {
  height: 200px;
  overflow-y: auto;
  padding: 15px;
  background-color: #f8f9fb;
  border: solid 1px #e5e7eb;
  border-radius: 8px;
  font-size: 18px;
  line-height: 1.8;
  white-space: pre-wrap;
  text-align: left;
}

.terms-checkbox-wrapper {
  margin-top: 15px;
  display: flex;
  justify-content: center;

  ::v-deep .el-checkbox.is-checked .el-checkbox__inner,
  ::v-deep .el-checkbox.is-checked.is-disabled .el-checkbox__inner {
    background-color: $color-primary;
    border-color: $color-primary;
  }

  ::v-deep .el-checkbox.is-checked.is-disabled {
    opacity: 1;
  }
}

/* 列印時分頁控制 */
.print-section-terms,
.print-section-signature {
  break-inside: avoid;
  page-break-inside: avoid;
}
</style>

<style lang="scss">
#print-area {
  position: absolute;
  top: -9999px; /* 移到畫面外 */
  left: -9999px;
}

@media print {
  @page {
    size: A4 portrait;
    margin: 10mm;
  }

  /* 預設全部不顯示 */
  body * {
    display: none !important;
  }

  /* 列印區塊顯示 */
  #print-area,
  #print-area * {
    display: block !important;
    visibility: visible !important;
  }

  #print-area .print-notShow {
    display: none !important;
    visibility: hidden !important;
  }

  #print-area {
    width: 195mm;
    margin: 0 auto;
    font-size: 14px;
    line-height: 1.6;
    position: static;
    padding: 0 !important;
  }

  #print-area .drawer-layout {
    padding: 0 !important;
  }

  #print-area .drawer-layout__scroll {
    padding: 0 !important;
  }

  #print-area .drawer-layout__content {
    padding: 20px 15px !important;
  }

  #print-area .drawer-layout__header {
    display: flex !important;
    justify-content: space-between !important;
    align-items: center !important;
    font-size: 20px;
    font-weight: 700;
    margin-bottom: 12px;
    padding: 8px 15px !important;
  }
}
</style>
